import type { ObjectId } from '@freightview/object-id'

type PrimaryAccountBrand = undefined | null
type AlternateAccountBrand = {
  mode: 'brand'
  _id: ObjectId
  name: string
  logoUri: string
}
type BlindBrand = {
  mode: 'none'
}
export type LoadBrand = PrimaryAccountBrand | AlternateAccountBrand | BlindBrand

export const isBlindBrand = (
  brand: Pick<LoadBrand, 'mode'>,
): brand is BlindBrand => brand?.mode === 'none'

export const isAlternateBrand = (
  brand: Pick<LoadBrand, 'mode'>,
): brand is AlternateAccountBrand => brand?.mode === 'brand'
